import { render } from "./ReadOnlyText.vue?vue&type=template&id=c23d8596&scoped=true"
import script from "./ReadOnlyText.vue?vue&type=script&lang=js"
export * from "./ReadOnlyText.vue?vue&type=script&lang=js"

import "./ReadOnlyText.vue?vue&type=style&index=0&id=c23d8596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23d8596"]])

export default __exports__